/**
 * Created by katarinababic on 11.6.25.
 */
import * as React from 'react';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { WeekDayEntryMindfulnessUnit } from '../../Model/Coach/Schedule/WeekDayEntryMindfulnessUnit';
import { useRootStore } from '../../Store/useRootStore';
import { useLocalized } from '../../Hooks/useLocalized';
import { useTrans } from '../../Store/System/LocalizationStore';
import { MindfulnessProgram, MindfulnessProgramApi } from '../../Model/Coach/Mindfulness/MindfulnessProgram';
import { StringUtils } from '../../Utils/StringUtils';
import { WorkoutDayCardEventListItem } from './WorkoutDayCardEventListItem';

export type WorkoutDayCardMindfulnessUnitProps = {
  entry: WeekDayEntryMindfulnessUnit;
};

export const WorkoutDayCardMindfulnessUnit: React.FC<WorkoutDayCardMindfulnessUnitProps> = observer(({ entry }) => {
  const { analytics } = useRootStore();
  const { t } = useTrans();
  const navigate = useNavigate();
  const unitName = useLocalized(entry.unit.unitTemplate?.name);

  const unit = entry.unit;
  const unitTemplate = entry.unit.unitTemplate;
  const totalExerciseTime = unitTemplate?.durationInMinutes ?? 0;
  const totalExerciseTimeText = totalExerciseTime ? t('globals.timeMin', { value: totalExerciseTime }) : undefined;

  const [program, setProgram] = useState<MindfulnessProgram | undefined>();
  const totalWeeks = program?.template?.weeksCount;
  const currentWeek = (program?.currentWeekIndex ?? -1) + 1;
  const displayTitle = unitName ? StringUtils.shortenString(unitName, 40) : '';

  useEffect(() => {
    MindfulnessProgramApi.get(unit.programId).then((res) => setProgram(res));
  }, [unit]);

  const handlePress = React.useCallback(() => {
    const templateId = unitTemplate?.id;
    if (templateId) {
      analytics.logSelectContent('meditation', templateId);
      navigate(`/mental-health/${templateId}`);
    }
  }, [unitTemplate, analytics, navigate]);

  const handleLongPress = React.useCallback(() => {
    // TODO implement alert
    // Alert.alert(
    //     t('mindfulnessUnitCard.skipAlert.title', { defaultValue: 'Skip this unit?' }),
    //     t('mindfulnessUnitCard.skipAlert.message', {
    //       defaultValue: "If you skip this unit you won't be able to do it again.",
    //     }),
    //     [
    //       {
    //         text: t('mindfulnessUnitCard.skipAlert.skipButton', { defaultValue: 'Skip unit' }),
    //         style: 'destructive',
    //         onPress() {
    //           unit.skip();
    //         },
    //       },
    //       {
    //         text: t('mindfulnessUnitCard.skipAlert.cancelButton', { defaultValue: 'Keep unit' }),
    //       },
    //     ],
    // );
  }, []);

  if (unitTemplate) {
    return (
      <WorkoutDayCardEventListItem
        title={displayTitle}
        subtitle={totalExerciseTimeText}
        imageSource={unitTemplate.largeImage}
        onPress={handlePress}
        onLongPress={handleLongPress}
        disabled={unit.skipped}
      />
    );
  }

  return null;
});
